import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight, Coins, Map } from "lucide-react";
import { ROADMAP_PHASES } from "@/lib/roadmapData";

// Compact homepage roadmap preview — reuses the shared ROADMAP_PHASES single source.
export default function RoadmapPreview() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16" data-testid="home-roadmap">
      <div className="flex items-end justify-between gap-4 flex-wrap mb-6">
        <div>
          <span className="tag bg-danger text-white" data-testid="home-roadmap-planned">PLANNED · SUBJECT TO CHANGE</span>
          <h2 className="headline text-cream text-3xl sm:text-5xl mt-4">THE <span className="text-neon">ROADMAP</span></h2>
          <p className="font-mono text-dim text-sm mt-2 max-w-xl">From a meme community to a multichain launch. Phase 1 is live — the rest is the plan.</p>
        </div>
        <Link to="/roadmap" className="btn-neon !py-2 !px-4 !text-sm shrink-0" data-testid="home-roadmap-cta">
          <Map className="w-4 h-4" /> View Full Roadmap <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      {/* Desktop: horizontal timeline / Mobile: horizontal scroll */}
      <div className="flex gap-4 overflow-x-auto pb-2 lg:grid lg:grid-cols-5 lg:gap-4 lg:overflow-visible snap-x">
        {ROADMAP_PHASES.map((p, i) => {
          const done = p.status === "COMPLETED";
          return (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              data-testid={`home-phase-${p.n}`}
              className={`snap-start shrink-0 w-[220px] lg:w-auto comic-card p-4 flex flex-col gap-3 ${done ? "border-neon" : ""}`}>
              <div className="flex items-center justify-between">
                <span className="w-9 h-9 grid place-items-center bg-ink3 border-3 border-black text-neon">
                  <p.Icon className="w-4 h-4" />
                </span>
                <span
                  data-testid={`home-phase-${p.n}-status`}
                  className={`tag !text-[9px] !px-2 !py-0.5 inline-flex items-center gap-1 ${done ? "bg-neon text-black" : "bg-gold text-black"}`}>
                  {done && <Check className="w-3 h-3" />} {p.status}
                </span>
              </div>
              <div>
                <p className="font-mono text-[10px] uppercase text-dim tracking-widest">Phase {p.n}</p>
                <h3 className="font-display font-900 uppercase text-cream text-sm leading-tight mt-0.5">{p.title}</h3>
              </div>
              {/* tiny progress spine */}
              <div className="mt-auto h-1.5 w-full bg-charcoal overflow-hidden">
                <div className={done ? "h-full w-full bg-neon" : "h-full w-0"} />
              </div>
            </motion.div>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-3 mt-6">
        <Link to="/roadmap" className="btn-ghost !py-2 !px-4 !text-sm" data-testid="home-roadmap-full">
          <Map className="w-4 h-4" /> View Full Roadmap
        </Link>
        <Link to="/tokenomics" className="btn-ghost !py-2 !px-4 !text-sm !border-gold hover:!bg-gold" data-testid="home-roadmap-tokenomics">
          <Coins className="w-4 h-4" /> View Tokenomics
        </Link>
      </div>
    </section>
  );
}
